import round from 'lodash/round';

const prepValue = function(value) {
  if (typeof value === 'string') {
    value = value.replace(/[$,]*/g, '');
  }

  value = parseFloat(value) || 0;

  if (isNaN(value)) {
    value = 0;
  }

  return value;
};

const add = function() {
  let result = 0;

  const sum = val => {
    result += prepValue(val);
  };

  for (let arg = 0; arg < arguments.length; ++arg) {
    if (Array.isArray(arguments[arg])) {
      arguments[arg].forEach(sum);
    } else {
      result += prepValue(arguments[arg]); // eslint-disable-line
    }
  }

  return round(result, 4);
};

const multiply = function() {
  let result;

  for (let arg = 0; arg < arguments.length; ++arg) {
    if (arg === 0) {
      result = prepValue(arguments[arg]); // eslint-disable-line
    } else {
      result *= prepValue(arguments[arg]); // eslint-disable-line
    }
  }

  return round(result, 4);
};

const subtract = function() {
  let result;

  for (let arg = 0; arg < arguments.length; ++arg) {
    if (arg === 0) {
      result = prepValue(arguments[arg]); // eslint-disable-line
    } else {
      result -= prepValue(arguments[arg]); // eslint-disable-line
    }
  }

  return round(result, 4);
};

const subtractToZero = function() {
  const result = subtract(...arguments);
  if (result < 0) {
    return 0;
  }

  return result;
};

const divide = function() {
  let result;

  for (let arg = 0; arg < arguments.length; ++arg) {
    if (arg === 0) {
      result = prepValue(arguments[arg]); // eslint-disable-line
    } else {
      result /= prepValue(arguments[arg]) || 1; // eslint-disable-line
    }
  }

  return round(result, 4);
};

const percentOf = function(value, percent) {
  return prepValue(value) * (prepValue(percent) / 100);
};

const negative = function(value) {
  return -Math.abs(prepValue(value));
};

// LUT15
const finalFuelCost = function(costPerUnit = 0, fixedUpCharge = 0, percentUpCharge = 0) {
  costPerUnit = prepValue(costPerUnit);
  fixedUpCharge = prepValue(fixedUpCharge);
  percentUpCharge = prepValue(percentUpCharge);

  return (costPerUnit * percentUpCharge) / 100 + costPerUnit + fixedUpCharge;
};

// AAR15
const sumByCondition = function(amounts = [], flag = [], condition) {
  let total = 0;

  const isRegex = /^\/(.*)\//;

  if (typeof condition === 'string' && isRegex.test(condition)) {
    condition = new RegExp(condition.match(isRegex)[1]);
  }

  const useRegex = condition instanceof RegExp;

  if (!Array.isArray(amounts)) {
    amounts = [amounts];
  }

  if (!Array.isArray(flag)) {
    flag = [flag];
  }

  amounts.forEach((amount, index) => {
    if (useRegex) {
      if (condition.test(flag[index])) {
        total = total + prepValue(amount) || 0;
      }
    } else {
      if (flag[index] === condition) {
        // eslint-disable-line
        total = total + prepValue(amount) || 0;
      }
    }
  });

  return round(total, 4);
};

// add and then subtract the last value
const addsub = function() {
  let result;

  for (let arg = 0; arg < arguments.length; ++arg) {
    if (arg === 0) {
      result = prepValue(arguments[arg]); // eslint-disable-line
    } else if (arg + 1 === arguments.length) {
      result -= prepValue(arguments[arg]); // eslint-disable-line
    } else {
      result += prepValue(arguments[arg]); // eslint-disable-line
    }
  }

  return round(result, 4);
};

// add and then subtract the last value
const addmulti = function() {
  let result;

  for (let arg = 0; arg < arguments.length; ++arg) {
    if (arg === 0) {
      result = prepValue(arguments[arg]); // eslint-disable-line
    } else if (arg + 1 === arguments.length) {
      result *= prepValue(arguments[arg]); // eslint-disable-line
    } else {
      result += prepValue(arguments[arg]); // eslint-disable-line
    }
  }

  return round(result, 4);
};

// sub and then add the last value
const subadd = function() {
  let result;

  for (let arg = 0; arg < arguments.length; ++arg) {
    if (arg === 0) {
      result = prepValue(arguments[arg]); // eslint-disable-line
    } else if (arg + 1 === arguments.length) {
      result += prepValue(arguments[arg]); // eslint-disable-line
    } else {
      result -= prepValue(arguments[arg]); // eslint-disable-line
    }
  }

  return round(result, 4);
};

// multiply and then subtract the last value
const multisub = function() {
  let result;

  for (let arg = 0; arg < arguments.length; ++arg) {
    if (arg === 0) {
      result = prepValue(arguments[arg]); // eslint-disable-line
    } else if (arg + 1 === arguments.length) {
      result -= prepValue(arguments[arg]); // eslint-disable-line
    } else {
      result *= prepValue(arguments[arg]); // eslint-disable-line
    }
  }

  return round(result, 4);
};

// multiply and then add the last value
const multiadd = function() {
  let result;

  for (let arg = 0; arg < arguments.length; ++arg) {
    if (arg === 0) {
      result = prepValue(arguments[arg]); // eslint-disable-line
    } else if (arg + 1 === arguments.length) {
      result += prepValue(arguments[arg]); // eslint-disable-line
    } else {
      result *= prepValue(arguments[arg]); // eslint-disable-line
    }
  }

  return round(result, 4);
};

// multiply params, last param is max result allowed
const multimax = function() {
  let result;

  for (let arg = 0; arg < arguments.length; ++arg) {
    if (arg === 0) {
      result = prepValue(arguments[arg]); // eslint-disable-line
    } else if (arg + 1 === arguments.length) {
      // Last Argument
      const max = prepValue(arguments[arg]);
      if (max && result > max) {
        result = max;
      }
    } else {
      result *= prepValue(arguments[arg]); // eslint-disable-line
    }
  }

  return round(result, 4);
};

const or = function() {
  for (let arg = 0; arg < arguments.length; ++arg) {
    if (prepValue(arguments[arg])) {
      return arguments[arg];
    }
  }

  // TODO Support user defined default if all are falsy
  return 0;
};

const daydiff = function(date1, date2) {
  if (!date1 || !date2) {
    return 0;
  }

  const date1Parts = date1.split('-');
  const date2Parts = date2.split('-');

  const date1Obj = new Date(parseInt(date1Parts[2]), parseInt(date1Parts[0]) - 1, parseInt(date1Parts[1]));
  const date2Obj = new Date(parseInt(date2Parts[2]), parseInt(date2Parts[0]) - 1, parseInt(date2Parts[1]));

  const timeDiff = date2Obj.getTime() - date1Obj.getTime();

  return Math.round(timeDiff / (1000 * 3600 * 24));
};

export default {
  add,
  addmulti,
  addsub,
  daydiff,
  divide,
  finalFuelCost,
  multiadd,
  multimax,
  multiply,
  multisub,
  negative,
  or,
  percentOf,
  subadd,
  subtract,
  subtractToZero,
  sumByCondition,
};
